import React from 'react';
import { Building2 } from 'lucide-react';

export function Header() {
  return (
    <header className="bg-white shadow">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col items-center text-center">
          <div className="flex items-center gap-3">
            <Building2 className="h-8 w-8 text-blue-600" />
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Community Association Investment Calculator</h1>
              <p className="text-sm text-gray-600">Calculate the impact of investments on your reserve assets</p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}